import { Helmet } from 'react-helmet-async';

/**
 * Метатеги для страницы профиля пользователя
 */
export const ProfilePageMeta = () => {
    return (
        <Helmet>
            <meta property="og:title" content="Смотрите! Это моя страница на Промптхабе." />
            <meta
                property="og:description"
                content="Здесь мои промпты для Алисы AI и других нейросетей, мой ИИндекс, брелоки и моё место в рейтинге пользователей ИИ."
            />
            <meta property="og:image" content="https://yastatic.net/s3/distribution/prompthub/og-image.png" />
        </Helmet>
    );
};
